import IndexationAPI from "../api/IndexationAPI";

export default {
  async loadAllIndexations({commit}) {
    const response = await new IndexationAPI().loadAllIndexations();
    commit("setAllIndexations", response);
  },

  async setIndexation({commit}, indexation) {
    const response = await new IndexationAPI().setIndexation(indexation);
    commit("addIndexation", response);
  },

  async editIndexation({commit}, indexation) {
    const response = await new IndexationAPI().editIndexation(indexation);
    commit("editIndexation", response);
  },
};
